export default function ErreurPaiement(){
    return <p>Paiement échoué!</p>
}